export interface TagProps {
  tag: string
}

export const useTagProps = () => ({
  tag: {
    type: String,
    default: 'div',
  },
})
